const formatSinglePlural = ({
  quantity, single, plural,
}) => (quantity === 1 ? single : plural);

export default formatSinglePlural;



// WEBPACK FOOTER //
// ./src/utils/formatSinglePlural.js